import { render, staticRenderFns } from "./SignatureSignDoc.vue?vue&type=template&id=4b829d9d"
import script from "./SignatureSignDoc.vue?vue&type=script&lang=js"
export * from "./SignatureSignDoc.vue?vue&type=script&lang=js"
import style0 from "./SignatureSignDoc.vue?vue&type=style&index=0&id=4b829d9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports